import { NgModule } from "@angular/core";
import { Routes, RouterModule } from "@angular/router";

import { PublicComponent } from "./public.component";
import { LandingComponent } from "./landing/landing.component";
import { PageNotFoundComponent } from "./page-not-found/page-not-found.component";
import { LoginComponent } from "./auth/login/login.component";
import { SignupComponent } from "./auth/signup/signup.component";
import { SignupConfirmationComponent } from "./auth/signup-confirmation/signup-confirmation.component";
import { AuthGuard } from "../core-services/auth-guard";
import { SearchResultComponent } from "./landing/search-result/search-result.component";
import { PortfullcalendarComponent } from "./portfullcalendar/portfullcalendar.component";
import { UploadCsvComponent } from "./landing/upload-csv/upload-csv.component";
import { ForgotPasswordComponent } from "./auth/forgot-password/forgot-password.component";
import { ResetPasswordComponent } from "./auth/reset-password/reset-password.component";
import { RateRequestComponent } from "./raterequest/rate-request/rate-request.component";
import { RateRequestListComponent } from "./raterequest/rate-request-list/rate-request-list.component";
import { VoyageDetailComponent } from "./voyage/voyage-detail/voyage-detail.component";
import { BookingDetailComponent } from "./voyage/booking-detail/booking-detail.component";
import { BookingDetailslistComponent } from "./voyage/booking-detailslist/booking-detailslist.component";
import { PlanselectionComponent } from "./auth/planselection/planselection.component";
import {NewPricingComponent} from "./auth/new-pricing/new-pricing.component"
import { AccessPermissionGuard } from "../core-services/access-permission.guard";
import { VoyagePerformanceComponent } from "./landing/ShippingLinePerformance/voyage-performance/voyage-performance.component";
import { VoyagePerformanceLevel2Component } from "./landing/ShippingLinePerformance/voyage-performance-level2/voyage-performance-level2.component";
import { VoyagePerformanceLevel3Component } from "./landing/ShippingLinePerformance/voyage-performance-level3/voyage-performance-level3.component";
import { PortListComponent } from "./admin/Ports/port-list/port-list.component";
import { PlanListComponent } from "./admin/plans/plan-list/plan-list.component";
import { VesselsListComponent } from "./admin/Vessels/vessels-list/vessels-list.component";
import { UserListComponent } from "./admin/User/user-list/user-list.component";
import { PrivacypolicyComponent } from "./privacypolicy/privacypolicy.component";
import { CookiespolicyComponent } from "./cookiespolicy/cookiespolicy.component";
import { TermsandconditionsComponent } from "./termsandconditions/termsandconditions.component";
import { AboutusComponent } from "./aboutus/aboutus.component";
import { ServicesComponent } from "./services/services.component";
import { VoyagePerformanceLevel4Component } from "./landing/ShippingLinePerformance/voyage-performance-level4/voyage-performance-level4.component";
import { TrackingComponent } from "./Tracking/tracking/tracking.component";
import { TrackingListComponent } from "./Tracking/tracking-list/tracking-list.component";
import { FrightquotationComponent } from "./frightquotation/frightquotation.component";
import { VerificationErrorComponent } from "./layout-views/verification-error/verification-error.component";

import { APIListComponent } from "./admin/APIs/api-list/api-list.component";
import { TradeAndPortIntelligenceComponent } from "./landing/ShippingLinePerformance/trade-and-port-intelligence/trade-and-port-intelligence.component";
import { NewsComponent } from "./news/news.component";
import { ShippingLinesComponent } from "./admin/shippinglines/shippinglines.component";

// GLS
import { LandingSplashComponent } from "./landing/search-result-splash/search-result-splash.component";
import { VoyageTrackerSplash } from "./voyagetrackersplash/voyagetrackersplash.component";
import { VoyageTrackerComponent } from "./voyagetracker/voyagetracker.component";

import { PortcalendarSplashComponent } from "./portcalendarsplash/portcalendarsplash.component";
import { OpenSearchComponent } from "./admin/open-searches/open-searches.component";
import { NewsStaticRoute } from "../Enum/Enum";
import { ScheduleComponent } from "./schedule/schedule.component";
import { AnalyticsComponent } from "./analytics/analytics.component";
import { MyRateRequestListComponent } from "./raterequest/my-rate-request/my-rate-request.component";
const publicRoutes: Routes = [
  {
    path: "",
    component: PublicComponent,
    children: [
      {
        path: "",
        component: LandingComponent,
      },
      {
        path: "portcalendarsplash",
        canActivate: [AccessPermissionGuard],
        component: PortcalendarSplashComponent,
      },
      {
        path: "voyagetracker",
        canActivate: [AccessPermissionGuard],
        component: VoyageTrackerComponent,
      },
      {
        path: "voyagetrackersplash",
        canActivate: [AccessPermissionGuard],
        component: VoyageTrackerSplash,
      },
      {
        path: "searchresultsplash",
        canActivate: [AccessPermissionGuard],
        component: LandingSplashComponent,
      },
      {
        path: "searchresult/:fromPortId/:toPortId/:date/:isSearch",
        canActivate: [AccessPermissionGuard],
        component: SearchResultComponent,
      },
      {
        path: "searchresult",
        canActivate: [AccessPermissionGuard],
        component: SearchResultComponent,
      },
      {
        path: "voyagedetail/:id/:fromPortId/:toPortId/:fromDate/:toDate/:shippingId/:findToDate",
        canActivate: [AccessPermissionGuard],
        component: VoyageDetailComponent,
      },
      {
        path: "voyagedetail/:id/:fromPortId/:toPortId/:fromDate/:toDate/:shippingId",
        canActivate: [AccessPermissionGuard],
        component: VoyageDetailComponent,
      },
      {
        path: "voyagedetail/:id/:toVesselsId/:fromPortId/:toPortId/:midPortId/:trashipment/:fromDate/:toDate",
        canActivate: [AccessPermissionGuard],
        component: VoyageDetailComponent,
      },
      {
        path: "voyagedetail/:id/:toVesselsId/:fromPortId/:toPortId/:midPortId/:trashipment/:fromDate/:toDate/:shippingId/:toShippingId",
        canActivate: [AccessPermissionGuard],
        component: VoyageDetailComponent,
      },
      {
        path: "bookingdetail/:id/:vesselsId/:fromPortId/:toPortId/:fCountryId/:toCountryId/:shippinglineId/:trashipment",
        canActivate: [AccessPermissionGuard],
        component: BookingDetailComponent,
      },

      {
        path: "portcalendar",
        canActivate: [AccessPermissionGuard],
        component: PortfullcalendarComponent,
      },
      {
        path: "raterequest/:id",
        canActivate: [AccessPermissionGuard],
        component: RateRequestComponent,
      },
      {
        path: "raterequest/:shipId/:fromPortId/:toPortId",
        canActivate: [AccessPermissionGuard],
        component: RateRequestComponent,
      },

      {
        path: "raterequestlist/:id",
        canActivate: [AccessPermissionGuard],
        component: RateRequestListComponent,
      },
      {
        path: "raterequestlist/:id/:viewoffer",
        canActivate: [AccessPermissionGuard],
        component: RateRequestListComponent,
      },
      {
        path: "raterequestlist",
        canActivate: [AccessPermissionGuard],
        component: RateRequestListComponent,
      },
      {
        path: "myraterequest",
        canActivate: [AccessPermissionGuard],
        component: MyRateRequestListComponent,
      },
      {
        path: "bookinglist",
        canActivate: [AccessPermissionGuard],
        component: BookingDetailslistComponent,
      },
      {
        path: "planselection",
        component: NewPricingComponent,
      },
      {
        path: "tradeandportintelligence",
        canActivate: [AccessPermissionGuard],
        component: TradeAndPortIntelligenceComponent,
      },
      {
        path: "voyageperformance",
        canActivate: [AccessPermissionGuard],
        component: VoyagePerformanceComponent,
      },
      {
        path: "voyageperformance/:id/:fromPortId/:toPortId/:year",
        canActivate: [AccessPermissionGuard],
        component: VoyagePerformanceLevel2Component,
      },
      {
        path: "voyageperformance/:id/:fromPortId/:toPortId/:monthId/:year",
        canActivate: [AccessPermissionGuard],
        component: VoyagePerformanceLevel3Component,
      },
      {
        path: "voyageperformanceregion",
        canActivate: [AccessPermissionGuard],
        component: VoyagePerformanceLevel4Component,
      },
      {
        path: "analytics",
        canActivate: [AccessPermissionGuard],
        component: AnalyticsComponent,
      },
      //start News routing
      //redirecting to external url for now
      {
        path: "news",
        component: NewsComponent
      },
      //start Admin Routing
      {
        path: "importschedulecsv",
        canActivate: [AccessPermissionGuard],
        component: UploadCsvComponent,
      },
      {
        path: "ports",
        canActivate: [AccessPermissionGuard],
        component: PortListComponent,
      },
      {
        path: "shippinglines",
        canActivate: [AccessPermissionGuard],
        component: ShippingLinesComponent,
      },
      {
        path: "plans",
        canActivate: [AccessPermissionGuard],
        component: PlanListComponent,
      },
      {
        path: "apis",
        canActivate: [AccessPermissionGuard],
        component: APIListComponent,
      },

      {
        path: "vessels",
        canActivate: [AccessPermissionGuard],
        component: VesselsListComponent,
      },
      {
        path: "users",
        canActivate: [AccessPermissionGuard],
        component: UserListComponent,
      },
      {
        path: "privacypolicy",
        component: PrivacypolicyComponent,
      },
      {
        path: "cookiespolicy",
        component: CookiespolicyComponent,
      },
      {
        path: "termsandconditions",
        component: TermsandconditionsComponent,
      },
      {
        path: "aboutus",
        component: AboutusComponent,
      },
      {
        path: "services",
        component: ServicesComponent,
      },
      {
        path: "tracking",
        canActivate: [AccessPermissionGuard],
        component: TrackingComponent,
      },
      {
        path: "tracking/:trackNumber",
        canActivate: [AccessPermissionGuard],
        component: TrackingComponent,
      },
      {
        path: "tracking/:shipId/:vesselsId/:fromPortId/:toPortId/:deptDate",
        canActivate: [AccessPermissionGuard],
        component: TrackingComponent,
      },
      {
        path: "trackingvoyage",
        canActivate: [AccessPermissionGuard],
        component: TrackingListComponent,
      },
      {
        path: "freightquotation/:shipId/:fromPortId/:toPortId",
        component: FrightquotationComponent,
      },
      {
        path: "freightquotation",
        component: FrightquotationComponent,
      },
      {
        path: "opensearch",
        canActivate: [AccessPermissionGuard],
        component: OpenSearchComponent,
      },
      {
        path: "schedule",
        component: ScheduleComponent,
      },
      {
        path: "signup",
        component: SignupComponent,
      },
      {
        path: "signup-confirmation",
        component: SignupConfirmationComponent,
      },
    ],
  },
  { path: "login", component: LoginComponent },
  { path: "forgotpassword", component: ForgotPasswordComponent },
  { path: "error", component: VerificationErrorComponent },
  {
    path: "resetpassword",
    component: ResetPasswordComponent,
  },
  { path: "**", component: PageNotFoundComponent },
];

@NgModule({
  imports: [RouterModule.forChild(publicRoutes)],
  exports: [RouterModule],
})
export class PublicRoutingModule {}
